import "./styles.less";

import { ArrowDownOutlined, ArrowUpOutlined } from "@ant-design/icons";
import { Col, Popover, Row, Skeleton, Space, Typography } from "antd";

import { PropComponentMode } from "../PropertyInterfaces";
import React, { useContext } from "react";
import { TimeAgo } from "../../Days/TimeAgo/web";
import { usePriceTag } from "./PriceTag.hook";
import { useTheme } from "../../../Styles/ThemeHook";
import { ConfigStateContext } from "../../../Contexts/Configurations/context";

const { Text, Paragraph } = Typography;

export interface PriceTagProps {
	price: Price;
	priceVariation?: PriceVaritation;
	commonExpenses?: CommonExpenses;
	temporalPrice?: number;
	operationType?: OperationType;
	temporalCurrency: Currency;
	showExpenses?: boolean;
	threeDigitsFormat?: boolean;
	showOperationType?: boolean;
	showPriceVariation?: boolean;
	showFromText?: boolean;
	mode?: PropComponentMode;
	shortExpensesText?: boolean;
	skeleton?: string;
	isProject?: boolean;
	loading?: boolean;
}

export function PriceTag({
	showExpenses = true,
	threeDigitsFormat = false,
	showOperationType = false,
	showPriceVariation = true,
	showFromText = true,
	shortExpensesText = true,
	mode = "auto",
	skeleton = "front",
	loading = false,
	...rest
}: PriceTagProps) {
	const { data } = usePriceTag({
		threeDigitsFormat,
		showFromText,
		shortExpensesText,
		mode,
		...rest,
	});
	const { theme } = useTheme();
	const { country_code } = useContext(ConfigStateContext);

	if (loading) {
		return <PriceTagSkeleton direction={skeleton !== "front" ? "horizontal" : "vertical"} />;
	}

	const PriceVariationIndicator = () => {
		const content = () => {
			return (
				<Paragraph>
					<Text>
						<TimeAgo date={data.price_variation.date} bold capitalize />
						{" " + "el precio del inmueble" + " "}
						<Text strong>
							{data.price_variation.difference > 0 ? "subiÃ³" : "bajÃ³"}
						</Text>
						{" " + "un" + " "}
						<Text strong>{data.price_variation.percentage}%</Text>.
						<br />
						{data.price_variation.amount && (
							<Text>
								{"Precio Anterior"}: {data.price_variation.text}
							</Text>
						)}
					</Text>
				</Paragraph>
			);
		};

		return (
			<Popover placement="bottom" content={content()} title={"Cambio de Precio"}>
				{data.price_variation.difference <= 0 ? (
					<ArrowDownOutlined
						style={{ color: theme.colors.successColor, marginRight: 10 }}
					/>
				) : (
					<ArrowUpOutlined style={{ color: theme.colors.errorColor, marginRight: 10 }} />
				)}
			</Popover>
		);
	};



	return (
		<Row gutter={8} align={"middle"} className="property-price-tag">
			<Col style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
				{showPriceVariation && data.price_variation && <PriceVariationIndicator />}
				<Text className="price" strong>
					{(!data?.price?.currency || !data?.price || data?.price.amount == 0 || data.price.amount < 5) ? "Consultar" : data.price.text
					}
				</Text>
				{country_code === "ce3" && <span className="qty-price">/noche</span>}
			</Col>
			{showOperationType && (
				<Col span={24}>
					<Text type={"secondary"} className="operation_type">
						{"Precio de"} {data.operationType.text}
					</Text>
				</Col>
			)}
			{showExpenses && !data.commonExpenses.hide && (
				<Col>
					<Text type={"secondary"} className="commonExpenses">
						{data.commonExpenses.text}
					</Text>
				</Col>
			)}
		</Row>
	);
}

export const PriceTagSkeleton = ({ direction }) => {
	return (
		<Space align={"end"} className="price-tag-skeleton" direction={direction}>
			<Skeleton.Button active />
			<Skeleton.Button active />
		</Space>
	);
};